<template>
    <div class="container pd15 whitebg">
        <el-row :gutter="25">
          <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
            <div id="sidebar1" class="twenfive">
              <!-- <div class="switch">
                <el-button class="leftfloat" size="small" ref="next" @click="next($event)" :nameid="this.idnext">上一篇</el-button>
                <el-button class="rightfloat" type="primary" ref="Previous" size="small" @click="next($event)" :nameid="this.idnode">下一篇</el-button>
                <div class="clearfix"></div>
              </div> -->
              <div class="fm clx ten">
                <div class="fmBox">
                  <div class="user" v-if='this.a != 1'>
                    <div class="title_digst">导航/NAVIGATE</div>
                    <p><a  @click="tomouth($event,infoObj.IssueID)">本期目录/Table of Contents</a></p>
                    
              <p><a href="javascript:0;" ref="next" @click="next($event)"    :nameid="this.idnext" v-show="this.idnext!=-1">下一篇/Next Article</a></p>
              <p><a href="javascript:0;" ref="Previous" @click="next($event)"   :nameid="this.idnode" v-show="this.idnode!=-1">上一篇/Previous Article</a></p>
                  </div>
                  <div class="user">
                    <div class="title_digst">工具/TOOLS</div>
                    <p><a @click="pdf(infoObj.PDFFile_Size,infoObj.ArticleID,infoObj.IsOA)" v-if="infoObj.PDFFile_Size>0" id="PDF_Download">下载 PDF/Download</a></p>
                    <p v-if='this.a != 1'><a href="#" @click="topaper">导出 /Export</a></p>
                    <p v-if='this.a != 1'><a @click="downXML(infoObj.ArticleID)">XML</a></p>
                  </div>
                  <div class="user">
                    <div class="title_digst">统计/STATISTICS</div>
                    <p>摘要浏览/Viewed<span class="rightfloat gray_text">{{infoObj.View_Times}}</span></p>
                    <p>全文下载/Downloads<span class="rightfloat gray_text">{{infoObj.Read_Times}}</span></p>
                    <p>HTML点击/Click<span class="rightfloat gray_text">{{infoObj.HtmlRead_Times}}</span></p>
                    <p v-if="isComment">评论/Comments<span class="rightfloat gray_text">{{comm}}</span></p>
                  </div>
                </div>


              </div>
            </div>

          </el-col>
          <el-col :xs="24" :sm="24" :md="19" :lg="19" :xl="19">
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="side_container">
                  <div id="digest_table">
                    <h3>
                      <span v-html="infoObj.Title"></span>
                      <!-- <a title="PDF下载" @click="pdf" v-if="infoObj.PDFFile_Size>0"><img src="../assets/images/pdf.jpg" width="20"></a>
                    <a title="HTML" :href="infoObj.HtmlFileUrl" target="_blank" v-if="infoObj.HtmlFileUrl"><img class="HTML_img" src="../assets/images/html.png" width="20">HTML</a>
                   <a title="二维码" @click="oniscode(infoObj.ArticleID)"  class="menthodsBut"><i class="list_img Scancode"></i></a> -->
                    </h3>
                    <div class="ml_methods">
                      <a @click="goHTML(infoObj.HtmlFileUrl,infoObj.ArticleID,infoObj.IsOA)" class="menthodsBut" v-if="infoObj.HtmlFileUrl" target="_blank">
             <i class="list_img browse"></i>
            [HTML]
            <font class="">({{infoObj.HtmlRead_Times}})</font>
          </a>
        
          <a @click="pdf(infoObj.PDFFile_Size,infoObj.ArticleID,infoObj.IsOA)" v-if="infoObj.PDFFile_Size>0 && !infoObj.PDFisurl"  class="menthodsBut">
            <i class="list_img down"></i>
           PDF下载
            <font
              class=""
            >({{infoObj.Read_Times}})</font>
          </a>
          <a :href="infoObj.PDFFileNameUrl" v-if='infoObj.PDFisurl && infoObj.PDFFileNameUrl' class="menthodsBut" target="_blank">
            <i class="list_img down"></i>
           PDF下载
            <font
              class=""
            >({{infoObj.Read_Times}})</font>
          </a>
          <!-- <a @click="oniscode(infoObj.ArticleID)" class="menthodsBut">
            <i class="list_img Scancode"></i>扫码
          </a> -->
                    </div>
                    <div class="copy_title">
                    <p class="text" style="background:transparent;border-style:none;width: 100%;height:auto;overflow-y:hidden;resize: none;outline: none"
                      ref="texta" v-html="infoObj.InCite"></p>
                    <span>
                      <el-button @click="copy" type="primary" size="mini">点击复制</el-button>
                    </span>
                  </div>
                   
                    <p class="ten detail_yjq">
                      <span>《{{setName}}》</span>
                      <span>[ISSN:{{ISSN}}/CN:{{CN}}]</span>
                      <span v-if="infoObj.Volume"><strong>卷: </strong>{{infoObj.Volume}}</span>
                      <span  v-if="infoObj.PublishYear"><strong>期数:</strong>{{infoObj.PublishYear}}年{{infoObj.IssueNum}}</span>
                      <span  v-if="infoObj.Column"><strong>栏目:</strong>{{infoObj.Column}}</span>
                      <span v-if="infoObj.Page_Num"><strong>页码:</strong>{{infoObj.Page_Num}}-{{infoObj.Page_NumEnd}}</span>
                      
                      <span v-if="infoObj.Publish_Date"><strong>出版日期:</strong></span>
                    
                      <span v-if="infoObj.Publish_Date">{{(infoObj.Publish_Date).substring(0,infoObj.Publish_Date.lastIndexOf("T"))}}</span>
                    </p>
                    <table class="table ten">
                      <tbody>
                      <tr v-if="isEnzhaiy">
                        <th scope="row" align="left" class="pclist">Title:</th>
                       
                        <td>
                           <p class="mobList">Title:</p>
                           <p v-html="infoObj.TitleE">

                           </p>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" align="left" class="pclist">作者:</th>
                        <td>
                          <!-- <p v-html="infoObj.AuthorsHTML"></p> -->
                          <p class="mobList">作者：</p>
                          <p v-show="this.a != 1"><a href="javascript:;" class="span" v-for="(a,i) in text" :key='i'><span @click="toSearch"  v-html="a"></span><span v-if="i != text.length-1"> ,</span></a></p>
                          <p v-show="this.a == 1" v-html="infoObj.AuthorsHTML">
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" align="left" class="pclist">Author(s):</th>
                        <td>
                          <!-- <p><a v-html="infoObj.AuthorsHTMLE"></a></p> -->
                           <p class="mobList">Author(s):</p>
                          <p  v-show="this.a != 1"><a href="javascript:;" class="span" v-for="(a,i) in actor" :key='i'><span @click="toSearch"  v-html="a"></span><span v-if="i != actor.length-1"> ,</span></a></p>
                          <p v-show="this.a == 1" v-html="infoObj.AuthorsHTMLE"></p>
                        </td>
                      </tr>


                      <tr>
                        <th scope="row" align="left" class="pclist">单位:</th>
                        <td>
                          <!-- <p><a v-html="infoObj.AuthorsHTMLE"></a></p> -->
                           <p class="mobList">Unit:</p>
                          <p  v-show="this.a != 1"><a href="javascript:;" class="span" v-for="(a,i) in Unit" :key='i'><span @click="toSearch"  v-html="a"></span><span v-if="i != Unit.length-1"> ,</span></a></p>
                          <p  v-show="this.a == 1" v-html="infoObj.Unit"></p>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" align="left" class="pclist">Unit:</th>
                        <td>
                          <!-- <p><a v-html="infoObj.AuthorsHTMLE"></a></p> -->
                           <p class="mobList">Unit_EngLish:</p>
                          <p  v-show="this.a != 1"><a href="javascript:;" class="span" v-for="(a,i) in Unit_EngLish" :key='i'><span @click="toSearch"  v-html="a"></span><span v-if="i != Unit_EngLish.length-1"> ,</span></a></p>
                          <p v-show="this.a == 1" v-html="infoObj.Unit_EngLish"></p>
                        </td>
                      </tr>



                      <tr>
                        <th scope="row" align="left" class="pclist">关键词:</th>
                        <td>
                          <p class="mobList">关键词:</p>
                          <!-- <span id="LbKeyC"><a rel="external" v-html="infoObj.Keyword_Chinese"></a></span> -->
                           <p  v-show="this.a != 1"><a href="javascript:;" class="span" v-for="(a,i) in key" :key='i'><span @click="toSearch"  v-html="a"></span><span v-if="i != key.length-1"> ;</span></a></p>
                           <p v-show="this.a == 1" v-html="infoObj.Keyword_Chinese"></p>
						   <!-- <p v-html="infoObj.Keyword_Chinese"></p> -->
                        </td>
                      </tr>
                      <tr v-if="isEnzhaiy">
                        <th scope="row" align="left" class="pclist">Keywords:</th>
                        <td>
                          <p class="mobList">Keywords:</p>
                          <!-- <span id="LbKeyE"><a rel="external" v-html="infoObj.Keywords_English"></a></span> -->
                          <p  v-if="this.a != 1"><a href="javascript:;"  class="span" v-for="(a,i) in keyEng"  :key='i'><span @click="toSearch"  v-html="a"></span><span v-if="i != keyEng.length-1"> ;</span></a></p>
                           <p v-if="this.a == 1" v-html="infoObj.Keywords_English"></p>
						   <!-- <p v-html="infoObj.Keywords_English"></p> -->
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" align="left" class="pclist">分类号:</th>
                        <td>
                          <p class="mobList">分类号:</p>
                          <p v-html="infoObj.ZTFLH">

                          </p>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" align="left" class="pclist">DOI:</th>
                        <td>
                          <p class="mobList">DOI:</p>
                          <p>
                              <a :href="'http://dx.doi.org/'+infoObj.DOI" target="_blank" rel="noopener noreferrer" class="doiurl"><span>{{infoObj.DOI}}</span></a>
                          </p>
                        </td>
                      </tr>
                       <tr>
                        <th scope="row" align="left" class="pclist">文献标识码:</th>
                        <td>
                          <p class="mobList">文献标识码:</p>
                          <p v-html="infoObj.WXBSM">
                            
                          </p>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" align="left" class="pclist">摘要:</th>
                        <td>
                          <p class="mobList">摘要:</p>
                          <p v-html="infoObj.Abstract_Chinese">
                            
                          </p>
                        </td>
                      </tr>
                      <tr v-if="isEnzhaiy">
                        <th scope="row" align="left" class="pclist">Abstract:</th>
                        <td>
                          <p class="mobList">Abstract:</p>
                          <p v-html="infoObj.Abstract_English">

                          </p>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" align="left" class="pclist">参考文献<br />/References:</th>
                        <td>
                          <p class="mobList">参考文献<br />/References:</p>
                          <p v-html="infoObj.Reference">

                          </p>
                        </td>
                      </tr>
                      <tr>
                        <th scope="row" align="left" class="pclist">备注/Memo:</th>
                        <td>
                          <p class="mobList">备注/Memo:</p>
                          <p v-html="infoObj.Memory">
                          </p>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <Comments :CommentList="CommentList" :comm='comm' v-if="isComment"></Comments>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
          <el-dialog
              :visible.sync="centerDialogVisible"  width="" center>
              <vue-qr :text="Url+'#/digest?ArticleID='+codeId" :size="150" class="Qrcode"></vue-qr>
          </el-dialog>
      </div>
</template>
<script>
import Comments from '../components/comment'
import vueQr from 'vue-qr'
export default {
    data(){
        return{
        form:[],
        List: [],
        infoObj: [],
        comm: 0,
        CommentList: [],
        Token: '',
        commentText: '', // 评论内容
        TotalComments: 1000, // 评论总条数
        checked: false, // 是否匿名发表
        cc: '',
        NickyName: "",
        aa: '',
        previos: '',
        isdownb:false,
        naxt: '',
        idnode: -1,
        issue:'',
        text: [],
        idnext: -1,
        bb: '',
        Title: '',
        newArr: [],
        actor: [],
        Unit:[],
        Unit_EngLish:[],
        key: [],
        Comments: '',
        keyEng: [],
        id: '',
        title: '',
        ida: '',
        indoe: "",
        inext: "",
        kind: 2,
        a:'',
        name:'',
        CanReview:false,
        isComment:false,
        isEnzhaiy:false,
        ISSN:"",
        CN:"",
        setName:"",
        centerDialogVisible: false,
        codeId:0,
        }
    },
    components:{
      Comments,
      vueQr
    },
    mounted(){
      if(localStorage.getItem("userInfo")){
      this.isdownb=true
    }
        this.a = sessionStorage.getItem('aa')
      var cc = localStorage.getItem("loginfo_user")
      var aa = location.href
      var num = aa.split("=")
      var index = 0
      
      var id = this.$route.query.ArticleID;
      this._getPLLB(id)
      if(sessionStorage.getItem("SetItem")){
        let SetItem=JSON.parse(sessionStorage.getItem("SetItem"))
      SetItem.map((item)=>{
          if(item.SetItemID==230){
              item.Item_Value=="是"?this.isComment=true:this.isComment=false
          }
          if(item.SetItemID==6055){
              item.Item_Value=="是"?this.isEnzhaiy=true:this.isEnzhaiy=false
          }
          if(item.SetItemID==5000){
             this.ISSN=item.Item_Value
          }
          if(item.SetItemID==5010){
             this.CN=item.Item_Value
          }
          if(item.SetItemID==1000){
             this.setName=item.Item_Value
          }
      })
      }else{
        let params = [1000,1001,4530,6018,6019,230,6055,5000,5010,99,96,11,2960,6021]
        this.$store.dispatch("_getSet",params).then(res=>{
          sessionStorage.setItem("SetItem",JSON.stringify(res.data.Data))
          let SetItem=res.data.Data
          SetItem.map((item)=>{
          if(item.SetItemID==230){
              item.Item_Value=="是"?this.isComment=true:this.isComment=false
          }
          if(item.SetItemID==6055){
              item.Item_Value=="是"?this.isEnzhaiy=true:this.isEnzhaiy=false
          }
          if(item.SetItemID==5000){
             this.ISSN=item.Item_Value
          }
          if(item.SetItemID==5010){
             this.CN=item.Item_Value
          }
          if(item.SetItemID==1000){
             this.setName=item.Item_Value
          }
      })
        }).catch(err=>{
          console.log(err)
        })
      }
      

      this._getLBXQ(id) //列表详情
    
      var bb = this.bb
      var a = document.getElementsByClassName("span")
      for (var i = 0; i < a.length; i++) {
        a[i].onclick = function() {
        }
      }
      this.title = this.infoObj.Title
    },
    methods:{
        _getLBXQ(id) {
        var time =new Date().getTime() 
        let params = {
          id
        }
        this.$store.dispatch("_getLBXQ",{id,'sec': time})
        .then(res => {
          this.infoObj = res.data.Data
          this.CanReview=res.data.Data.CanReview
          this.Title = this.infoObj.Title
          this.id = this.infoObj.ArticleID
          var a = this.infoObj.IssueID
          sessionStorage.setItem('a',a)
          document.title = res.data.Data.Title
        if(res.data.Data.AuthorsHTML){
           for(var num=0;num<res.data.Data.AuthorsHTML.length;num++){
        if(res.data.Data.AuthorsHTML.charAt(num)==','){
        if(res.data.Data.AuthorsHTML.charAt(num-1)=='>'){
          res.data.Data.AuthorsHTML=this.changeStr(res.data.Data.AuthorsHTML,num,'#')
        }
        }
      }
      
          if(res.data.Data.AuthorsHTML.indexOf('#') != -1){
            this.text = res.data.Data.AuthorsHTML.split("#")
          }else if(res.data.Data.AuthorsHTML.indexOf('、') != -1){
            this.text = res.data.Data.AuthorsHTML.split("、")
          }else if(res.data.Data.AuthorsHTML.indexOf(';') != -1){
            this.text = res.data.Data.AuthorsHTML.split(";")
          }else if(res.data.Data.AuthorsHTML.indexOf('；') != -1){
            this.text = res.data.Data.AuthorsHTML.split("；")
          }else if(res.data.Data.AuthorsHTML.indexOf(' ;') != -1){
            this.text = res.data.Data.AuthorsHTML.split(" ;")
          }else if(res.data.Data.AuthorsHTML.indexOf(',') != -1){
            this.text = res.data.Data.AuthorsHTML.split(",")
          }
          else{
            this.text = res.data.Data.AuthorsHTML.split("，")
          }
        }
         
      if(res.data.Data.AuthorsHTMLE){
        for(var num=0;num<res.data.Data.AuthorsHTMLE.length;num++){
        if(res.data.Data.AuthorsHTMLE.charAt(num)==','){
        if(res.data.Data.AuthorsHTMLE.charAt(num-1)=='>'){
          res.data.Data.AuthorsHTMLE=this.changeStr(res.data.Data.AuthorsHTMLE,num,'#')
        }
        }
      }

          if(res.data.Data.AuthorsHTMLE){
            if(res.data.Data.AuthorsHTMLE.indexOf('#') != -1){
            this.actor = res.data.Data.AuthorsHTMLE.split("#") 
          }else if(res.data.Data.AuthorsHTMLE.indexOf(', ') != -1){
            this.actor = res.data.Data.AuthorsHTMLE.split(", ")
          }
          else if(res.data.Data.AuthorsHTMLE.indexOf('；') != -1){
            this.actor = res.data.Data.AuthorsHTMLE.split("；")
          }else if(res.data.Data.AuthorsHTMLE.indexOf(';') != -1){
            this.actor = res.data.Data.AuthorsHTMLE.split(";")
          }else if(res.data.Data.AuthorsHTMLE.indexOf('、') != -1){
            this.actor = res.data.Data.AuthorsHTMLE.split("、")
          }
          else{
            this.actor = res.data.Data.AuthorsHTMLE.split("，")
          }
          }
      }
      

          if(res.data.Data.Unit){
            if(res.data.Data.Unit.indexOf('#') != -1){
            this.Unit = res.data.Data.Unit.split("#") 
          }else if(res.data.Data.Unit.indexOf(', ') != -1){
            this.Unit = res.data.Data.Unit.split(", ")
          }
          else if(res.data.Data.Unit.indexOf('；') != -1){
            this.Unit = res.data.Data.Unit.split("；")
          }else if(res.data.Data.Unit.indexOf(';') != -1){
            this.Unit = res.data.Data.Unit.split(";")
          }else if(res.data.Data.Unit.indexOf('、') != -1){
            this.Unit = res.data.Data.Unit.split("、")
          }
          else{
            this.Unit = res.data.Data.Unit.split("，")
          }
          }
          if(res.data.Data.Unit_EngLish){
            if(res.data.Data.Unit_EngLish.indexOf('#') != -1){
            this.Unit_EngLish = res.data.Data.Unit_EngLish.split("#") 
          }else if(res.data.Data.Unit_EngLish.indexOf(', ') != -1){
            this.Unit_EngLish = res.data.Data.Unit_EngLish.split(", ")
          }
          else if(res.data.Data.Unit_EngLish.indexOf('；') != -1){
            this.Unit_EngLish = res.data.Data.Unit_EngLish.split("；")
          }else if(res.data.Data.Unit_EngLish.indexOf(';') != -1){
            this.Unit_EngLish = res.data.Data.Unit_EngLish.split(";")
          }else if(res.data.Data.Unit_EngLish.indexOf('、') != -1){
            this.Unit_EngLish = res.data.Data.Unit_EngLish.split("、")
          }
          else{
            this.Unit_EngLish = res.data.Data.Unit_EngLish.split("，")
          }
          }

          if(res.data.Data.Keyword_Chinese){
            if(res.data.Data.Keyword_Chinese.indexOf(',') != -1){
            this.key = res.data.Data.Keyword_Chinese.split(",")
          }
          else if(res.data.Data.Keyword_Chinese.indexOf('、') != -1){
            this.key = res.data.Data.Keyword_Chinese.split("、")
          }else if(res.data.Data.Keyword_Chinese.indexOf(';') != -1){
            this.key = res.data.Data.Keyword_Chinese.split(";")
          }else if(res.data.Data.Keyword_Chinese.indexOf('；') != -1){
            this.key = res.data.Data.Keyword_Chinese.split("；")
          }else if(res.data.Data.Keyword_Chinese.indexOf(' ;') != -1){
            this.key = res.data.Data.Keyword_Chinese.split(" ;")
          }
          else{
            this.key = res.data.Data.Keyword_Chinese.split("，")
          }
          }
          if(res.data.Data.Keywords_English){
            if(res.data.Data.Keywords_English.indexOf(',') != -1){
            this.keyEng = res.data.Data.Keywords_English.split(",")
          }else if(res.data.Data.Keywords_English.indexOf('、') != -1){
            this.keyEng = res.data.Data.Keywords_English.split("、")
          }
          else if(res.data.Data.Keywords_English.indexOf(';') != -1){
            this.keyEng = res.data.Data.Keywords_English.split(";")
          }
           else if(res.data.Data.Keywords_English.indexOf('；') != -1){
            this.keyEng = res.data.Data.Keywords_English.split("；")
          }
          else{
            this.keyEng = res.data.Data.Keywords_English.split("，")
          }
          }
          this.name = res.data.Data.AuthorsHTML
          this._getNewlist()
        }).catch(err => {
          console.log("err", err)
        })
      },
      //  oniscode(num){
      //   this.centerDialogVisible=true
      //  this.codeId=num
      // },
       changeStr(str,index,changeStr){
        return str.substr(0, index) + changeStr+ str.substr(index + changeStr.length);
      },
      goHTML(url,ids,isoa){
      if(!this.isdownb){
        if(!isoa){
        alert("只有登录用户才可以查看HTML")
        return;
      }else{
         this.$store.dispatch("_getHtmlRead",{id:ids}).then(res=>{
      }).catch(err=>{
        console.log(err)
      })
     this.$newOpen(url)
      }
      }else{
        this.$store.dispatch("_getHtmlRead",{id:ids}).then(res=>{
      }).catch(err=>{
        console.log(err)
      })
     this.$newOpen(url)
      }
      
    },
      downXML(id){
        let params={
          ArticleID:id
        }
        this.$store.dispatch("_getdownXML",params).then(res=>{
          if (res.data.IsSuccess) {
            this.$Download.DownloadBase64File(
              res.data.Data.File,
              res.data.Data.FileName
            );
          } else {
            alert("下载失败");
          }
        }).catch(err=>{
          console.log(err)
        })
      },
      _getPLLB(id){
        var id = id
        let params = {
          Type: 2,
          ID: id,
          PageSize: 3
        }
        var a = sessionStorage.getItem('aa')
        if (a == 1) {
          params.Type = 4
        } else {
          params.Type = 2
        }
         this.$store.dispatch("_getPLLB",params)
        .then(res => {
          if (res.data.IsSuccess) {
            this.CommentList = res.data.Data
            this.comm = res.data.ItemCount
          }
        }).catch(err => {
          console.log("err", err)
        })
      },
      _getNewlist() {
        var a = sessionStorage.getItem('a')
        var id = this.infoObj.IssueID
        // var id = this.infoObj
        let params = {
          PageSize: -1,
          IssueId: id
        }
        this.$store.dispatch("_getNewlist",params)
        .then(res => {
          this.List = res.data.Data
          this.cc = this.infoObj.ArticleID
          let index = this.List.findIndex(item => item.ArticleID == this.cc)
          var id = this.$route.query.ArticleID
          this._getPLLB(id)
          for (var i = 0; i < this.List.length; i++) {
            if (this.List[i].ArticleID == id) {
              if (i == 0) {
                // this.naxt = '下一篇：' + this.List[i + 1].Title
                // this.$refs.next.innerHTML = '下一篇：' + this.List[i + 1].Title
                this.idnode = -1;
                this.idnext = this.List[i + 1].ArticleID;
              } else if (i == this.List.length - 1) {
                // this.previos = "上一篇：" + this.List[i - 1].Title
                // this.$refs.Previous.innerHTML = "上一篇：" + this.List[i - 1].Title
                this.idnext = -1
                this.idnode = this.List[i - 1].ArticleID
              } else {
                this.naxt = '下一篇：' + this.List[i + 1].Title
                this.previos = "上一篇：" + this.List[i - 1].Title
                // this.$refs.next.innerHTML = '下一篇：' + this.List[i + 1].Title
                // this.$refs.Previous.innerHTML = "上一篇：" + this.List[i - 1].Title
                this.idnode = this.List[i - 1].ArticleID //上一篇
                this.idnext = this.List[i + 1].ArticleID //下一篇
                this.indoe = this.List[i - 1].ArticleID //上一篇
                this.inext = this.List[i + 1].ArticleID //下一篇
              }
            }
          }
        }).catch(err => {

        })
      },

      _getXZCS(id) {
        let params = {
          Id: id
        }
        this.$store.dispatch('_getXZCS',params)
        .then(res => {
        }).catch(err => {
        })
      },
  
      pdf(size, guid,isoa){
         if(!this.isdownb){
        if(!isoa){
        alert("只有登录用户才可以下载")
        return;
        }else{
           if (size <= 0) {
        alert("文件不存在");
        return;
      }
        }
      }
      else{
        if (size <= 0) {
        alert("文件不存在");
        return;
      }
      }
         this.$store.dispatch("_getPDF", { Id: guid }).then(Result => {
         window.open(Result.request.responseURL);
      })
      },
      //跳转到文献导出页面
      topaper(e) {
        var ids = this.infoObj.ArticleID;
        e.preventDefault();
        this.$router.push({
          path: "/Export?ids=" + ids
        });
        
      },
      //点击复制
      copy() {
        var text = this.$refs.texta
        var Url2 = this.$refs.texta.innerText
        var oInput = document.createElement("input");
        oInput.value = Url2;
        document.body.appendChild(oInput);
        oInput.select(); 
        document.execCommand("Copy"); 
        oInput.className = "oInput";
        oInput.style.display = "none";
        alert("复制成功");
      },
      next(elem) {
        var id = elem.target.getAttribute("nameid");
         this.$refs.next.href = '#/digest?ArticleID=' + id
         this.$refs.Previous.href = '#/digest?ArticleID=' + id
        for (var i = 0; i < this.List.length; i++) {
          if (this.List[i].ArticleID == id) {
            if (i == 0) {
              this.idnode = -1;
              this.idnext = this.List[i + 1].ArticleID;
            } else if (i == this.List.length - 1) {
              this.idnext = -1
              this.idnode = this.List[i - 1].ArticleID
            } else {
              this.idnode = this.List[i - 1].ArticleID 
              this.idnext = this.List[i + 1].ArticleID 
            }
          }
        }
         this._getNewlist()
        this._getLBXQ(id);
        this._getPLLB()
      },
      
      tomouth(e, id) {
        var a = this.infoObj.YearIssue_No.split('期')
        var year = a[0]
        sessionStorage.setItem('year',year)
        let routeUrl = this.$router.resolve({
             path: '/OAList?IssueId='+id
           });
           window.open(routeUrl.href, '_blank');
      },
     toSearch(e) {
        var put = e.target.innerText
        if(put.indexOf('1') != -1){
          var a = put.split('1')[0]
          var b = a
        }else if(put.indexOf('2') != -1){
          var a = put.split('2')[0]
          var b = a
        }else if(put.indexOf('3') != -1){
          var a = put.split('3')[0]

        }else{
          var a = put
        }
        var b = a
        var name = e.target.className
        localStorage.setItem('value', b)
        if(b!= ''){
          e.preventDefault()
            let routeUrl = this.$router.resolve({
              path: '/QuickSearch'
            });
            window.open(routeUrl.href, '_blank');
        }

      },
      
    },
    watch:{
        $route: {
          handler() {
              let id = this.$route.query.ArticleID;
              this._getPLLB(id)
        },
        deep: true,
    }
      }
}
</script>
<style scoped>
@media (max-width:768px){
  table,tbody{ width: 100%; display: block;}
table tr{ line-height: 30px; width: 100%; display: block;}

table tr  td{width: 100%; display: block;}
table tr td p{width: 100%; display: block;overflow-wrap: break-word;}
}
table tr{ line-height: 30px;}
table tr th{ width: 120px;}
tr:nth-child(even){border-bottom:1px #dddddd solid; padding: 0;}
td:nth-child(even){border-bottom:1px #dddddd solid; padding: 0;}
th:nth-child(even){border-bottom:1px #dddddd solid; padding: 0;}
a{
  color: #333;
  font-size: 12px;
  font-weight: 400;
}
 .HTML_img {
    width: 15px;
    height: auto;
    margin-right: 5px;
    position: relative;
    top: 2px;
}
.side_container h3 a{
  margin: 0 8px;
}
</style>